import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getTempInfo} from '../../common'
import {getQuestionnaireList,saveRiskResult,previewPlanRisk,stopPlanByRiskResult} from '../../action/questionnairesAction';
import { Result, Toast } from 'antd-mobile/lib';
import Util from '../../util.js';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';
import ModelEvaluation from '../Modal/ModelEvaluationcopy';
import {AlerModleCommon} from '../fundDetail/AlerModle';
import { traceSave } from "../../action/riskInPayAction";
import './Question.css'
class QuestionnaireList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionnaireType: '公募',
      questionnaireTypeNumber: 3,
      questionnaireNumber: 1,
      questionnaireTotalNumber: 1,
      questionnaireArray: [{content: '', options: []}],
      loadingFlag: false,
      disableSelectItem: false,
      alertFlag:false,
      stopType:'',
      yyrgArr:[],
      dtjhArr:[],
      alertContent:'根据最新的评测结果，超出风险承受能力的计划类交易将被终止。如果您对自己的风险等级有异议，建议重新测评。'
    };
    this.answers = [];
    this.questionnaireSelectedOption=[];
  }
  componentWillMount(){
    document.title = "公募答题问卷"
    this.toGetQuestionnaireList();
  }
  async toGetQuestionnaireList(){
    let params = {
      token: await getTempInfo('shortToken'),
      questionnaireNo: this.state.questionnaireTypeNumber,
    }
    console.log(params)
    this.props.dispatch(getQuestionnaireList(params, (questionnaireList)=>{this.getQuestionnaireSuccess(questionnaireList)}, (msg)=>{this.getQuestionnaireError(msg)}))
    
  }
  getQuestionnaireSuccess(questionnaireList){
    this.setState({
      questionnaireArray: questionnaireList,
      questionnaireTotalNumber: questionnaireList.length,
    });
    console.log(questionnaireList,questionnaireList.length)
  }

  getQuestionnaireError(msg){
    
  }
  handleSelectedOption(key){
    this.setState({disableSelectItem: false})
      this.answers.push({answerNo: `${this.state.questionnaireNumber}`, optionNo: key,});
      this.setState({
        questionnaireNumber: this.state.questionnaireNumber+1,
      }); 
    // console.log(this.answers,'*******',this.state.questionnaireNumber);
  }
  
  clickItem(i){
    if(this.state.disableSelectItem){
      return;
    }
    this.questionnaireSelectedOption=this.questionnaireSelectedOption.slice(0,this.state.questionnaireNumber-1)
    this.questionnaireSelectedOption.push(this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].optionId)
    this.setState({
      disableSelectItem: true
    })
    setTimeout(()=>this.handleSelectedOption(this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].optionId),40)
  
    
  }
  async handleSaveRiskResult(key){
    this.setState({loadingFlag: true});
    if(this.answers.length<this.state.questionnaireTotalNumber){
        this.answers.push({answerNo: `${this.state.questionnaireNumber}`, optionNo: key,})
    }
    let params = {
      token: await getTempInfo('shortToken'),
      raiseMethod: '9',
      questionnaireNo: this.state.questionnaireTypeNumber,
      answers: JSON.stringify(this.answers),
    };
    this.props.dispatch(previewPlanRisk(params,(result) => {
      let xzRiskArr = [];
      let riskMismatch = [];
      let yyrgArr = [];
      let dtjhArr = [];
      if(result&&result.length > 0 ){
        if(result[0].riskRearRank == "1"){
          /* 答了 R1 */
          for(let ii=0; ii<result.length; ii++){
              if(result[ii].planType == "10" && Number(result[ii].riskLevel) > Number(result[ii].riskRearRank)){
                yyrgArr.push(result[ii].fundName)
              }else if(result[ii].planType != "10" && Number(result[ii].riskLevel) > Number(result[ii].riskRearRank)){
                dtjhArr.push(result[ii].fundName)
              }
          }
          if(yyrgArr.length > 0 || dtjhArr.length > 0){
            let showContent = dtjhArr.length > 0 && yyrgArr.length > 0 ? `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。具体包括：${ dtjhArr },${ yyrgArr }。如果您对自己的风险等级有异议，建议重新评测。` : 
            dtjhArr.length > 0 && yyrgArr.length == 0 ? `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。具体包括：${ dtjhArr }。如果您对自己的风险等级有异议，建议重新评测。` : dtjhArr.length == 0 && yyrgArr.length > 0 ? `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。具体包括：${ yyrgArr }。如果您对自己的风险等级有异议，建议重新评测。` : `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。如果您对自己的风险等级有异议，建议重新评测。`
            this.setState({
              alertFlag:true,
              alertContent:showContent,
              stopType:""
            })
          }else{
            this.props.dispatch(saveRiskResult(params, (content)=>{this.saveRiskResultSuccess(content)}, (msg)=>{this.saveRiskResultError(msg)}));
          }
        }else{
          for(let i=0; i<result.length; i++){
            if( Number(result[i].riskLevel) > Number(result[i].riskRearRank) ){
                if(result[i].raiseMethod == "6" || result[i].raiseMethod == "8"){
                  /*资管类、且产品风险等级大于答问券风险等级*/
                  xzRiskArr.push(result[i])
                }else{
                  riskMismatch.push(result[i])
                }
            }
          }
          if(xzRiskArr.length > 0){
            for(let j=0; j<xzRiskArr.length; j++){
              if(xzRiskArr[j].planType == "10"){
                yyrgArr.push(xzRiskArr[j].fundName)
              }else{
                dtjhArr.push(xzRiskArr[j].fundName)
              }
            }
            let yyrgArr2 = [];
            let dtjhArr2 = [];
            for(let kk=0; kk<riskMismatch.length; kk++){
              if(riskMismatch[kk].planType == "10"){
                yyrgArr2.push(riskMismatch[kk].fundName)
              }else{
                dtjhArr2.push(riskMismatch[kk].fundName)
              }
            }
            let showContent = dtjhArr.length > 0 && yyrgArr.length > 0 ? `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。具体包括：${ dtjhArr },${ yyrgArr }。如果您对自己的风险等级有异议，建议重新评测。` : 
                dtjhArr.length > 0 && yyrgArr.length == 0 ? `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。具体包括：${ dtjhArr }。如果您对自己的风险等级有异议，建议重新评测。` : dtjhArr.length == 0 && yyrgArr.length > 0 ? `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。具体包括：${ yyrgArr }。如果您对自己的风险等级有异议，建议重新评测。` : `根据最新的评测结果，超出风险承受能力的计划类交易将被终止。如果您对自己的风险等级有异议，建议重新评测。`
            this.setState({
              alertFlag:true,
              stopType:"1",
              alertContent:showContent,
              yyrgArr:yyrgArr2,
              dtjhArr:dtjhArr2
            })
          }else{
            for(let k=0; k<riskMismatch.length; k++){
              if(riskMismatch[k].planType == "10"){
                yyrgArr.push(riskMismatch[k].fundName)
              }else{
                dtjhArr.push(riskMismatch[k].fundName)
              }
            }
            this.setState({
              yyrgArr,
              dtjhArr
            },()=> {
              console.log("没有限制只有不匹配，提交答案走结果页") 
              this.props.dispatch(saveRiskResult(params, (content)=>{this.saveRiskResultSuccess(content)}, (msg)=>{this.saveRiskResultError(msg)}));
            })
          }
        }
      }else{
        console.log("[], 提交答案走结果页")
        this.props.dispatch(saveRiskResult(params, (content)=>{this.saveRiskResultSuccess(content)}, (msg)=>{this.saveRiskResultError(msg)}));
      }
      console.log(result,"是否匹配返回")

    },(msg)=>{
      this.setState({
        loadingFlag: false,
        disableSelectItem:false
      });
      Toast.info(msg, Util.ToastTime);
      this.answers.pop();
      console.log(msg,"msg")
    } ))
    // this.props.dispatch(saveRiskResult(params, (content)=>{this.saveRiskResultSuccess(content)}, (msg)=>{this.saveRiskResultError(msg)}));
    // this.props.navigator.popToRoute(this.props.route);
  }
  saveRiskResultSuccess(content){
    this.setState({loadingFlag: false});
    this.setState({disableSelectItem: false})
    console.log(this.props.location)
    let {dtjhArr,yyrgArr} = this.state;
    let tipVal=''
    let showContent = dtjhArr.length > 0 && yyrgArr.length > 0 ? `超出风险承受能力的计划类交易：${ dtjhArr },${ yyrgArr }。` : 
        dtjhArr.length > 0 && yyrgArr.length == 0 ? `超出风险承受能力的计划类交易：${ dtjhArr }。` : dtjhArr.length == 0 && yyrgArr.length > 0 ? `超出风险承受能力的计划类交易：${ yyrgArr }。` : ""
    // if(this.props.location.state.raiseMethod=='9'){
      let fundList=''
      for (let i = 0; i < content.fundList.length; i++) {
       fundList+=content.fundList[i].fundName;
       (i<content.fundList.length-1)?fundList+='、':fundList+='。'
      }
      console.log(content.fundList,'xxxxx')
      if (content.hasDiffFunds) {
        tipVal=`您最新的风险等级为${content.rank}，上一次测评结果为${content.lastRankName?content.lastRankName:'空'}。`+(content.fundList.length!=0?`您持有中的部分产品与您的风险等级不匹配，请注意持仓风险：${ fundList } ${ showContent }`:`${ showContent }` )
      }else{
        tipVal=`您最新的风险等级为${content.rank}，上一次测评结果为${content.lastRankName?content.lastRankName:'空'}。`+(content.fundList.length!=0?`您持有中的产品与您的风险等级完全匹配。`:`${ showContent }` )
      }
      
    // }
    hashHistory.replace({
      pathname:'/FinishQuestionnaireSuccess',
      state: {
        title:'调查问卷',
        content:'恭喜您完成了风险测评问卷，您的风险测评结果为：',
        dataSouse:[['投资人姓名：',content.name],['问卷编号：',content.questionnaireNo],['问卷得分：',content.score],['风险承受能力：',content.rank]],
        tipVal:tipVal,
        route: this.props.location.state.route,
        refreshPage: this.props.location.state.refreshPage,
      } 
    })
    
    // hashHistory.replace({
    //   pathname:'/FinishQuestionnaireSuccess',
    //   state: {
    //     title:'调查问卷',
    //     content:'恭喜您完成了风险测评问卷，您的风险测评结果为：',
    //     dataSouse:[['投资人姓名：',content.name],['问卷编号：',content.questionnaireNo],['问卷得分：',content.score]
    //     ,['风险承受能力：',content.rank]],
    //     tipVal:tipVal,
    //     refreshPage:this.props.location.state.refreshPage,route:this.props.location.state.route
    //   },
    // })
  }

  saveRiskResultError(msg){
    this.setState({loadingFlag: false});
    this.setState({disableSelectItem: false})
    Toast.info(msg, Util.ToastTime );
    this.answers.pop();
  }
  handleGo() {
    this.setState({
      loadingFlag:false,
      disableSelectItem:false,
      alertFlag:false,
      questionnaireNumber: 1,
    })
    this.answers = [];
}
async closeMoadl(key){
  let { dispatch } = this.props;
  if(this.answers.length<this.state.questionnaireTotalNumber){
      this.answers.push({answerNo: `${this.state.questionnaireNumber}`, optionNo: key,})
  }
  console.log(this.state.questionnaireTypeNumber,"questionnaireNoquestionnaireNoquestionnaireNo")
  let params = {
    token: await getTempInfo('shortToken'),
    questionnaireNo: this.state.questionnaireTypeNumber,
    answers: JSON.stringify(this.answers),
    stopType:this.state.stopType  /* 1：专户基金，0：非专户基金，空：所有基金 */
  };

  dispatch(stopPlanByRiskResult(params,(res)=>{
      Toast.info("终止成功", Util.ToastTime);
      console.log(res,"终止")
      dispatch(traceSave({action: 'BUY_RISK_WARN_FIRST', message:'重新测评后，用户确认终止风险不匹配的计划类交易' }));/*终止留痕*/
      dispatch(saveRiskResult(Object.assign(params,{raiseMethod: this.props.location.state.raiseMethod,}), (content)=>{this.saveRiskResultSuccess(content)}, (msg)=>{this.saveRiskResultError(msg)}));
  },(err)=>{
       Toast.info(err, Util.ToastTime);
      console.log(err,"终止err")
  } ))
  this.setState({
    alertFlag:false,
    loadingFlag:false
  })
}
  render(){
    let {navigator} = this.props;
    let optionsArray = [];
    console.log(this.props.location)
    // 1~(n-1)页问题列表
    if(this.state.questionnaireNumber<=this.state.questionnaireTotalNumber-1){
      optionsArray.push(
        <p className='share' style = { {color: '#5b6370',height:'auto',paddingBottom:'10px'} } key='1'>
          {`${this.state.questionnaireNumber}、${this.state.questionnaireArray[this.state.questionnaireNumber-1].content}`}
        </p>
      )
      for (let i = 0; i <this.state.questionnaireArray[this.state.questionnaireNumber-1].options.length; i++) {
        console.log(`数组：${this.answers.length}，下标${this.state.questionnaireNumber-1},什么东西${this.answers[this.state.questionnaireNumber-1]}`)
        console.log(this.questionnaireSelectedOption,this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].optionId)
        optionsArray.push(
          <div onClick={()=>this.clickItem(i) } disabled={this.state.disableSelectItem}>
            <div  style={{display: "-webkit-flex",WebkitAlignItems:'center',background: '#fff',borderBottom: '1px solid rgba(242,245,247,1)',height:'62px'}}>
              { this.questionnaireSelectedOption[this.state.questionnaireNumber-1]==this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].optionId?
                <img style={{width:'0.88rem',height:'0.88rem'}}  src={require('../../img/protocol_selected.png')} />:
                <img style={{width:'0.88rem',height:'0.88rem'}} src={require('../../img/square.png')} />
              }
              <p style={{WebkitFlex:1}}>{this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].content}</p>
            </div>
          </div>
        )
      }
      // 第一页不显示上一题按钮
      this.state.questionnaireNumber==1?
      optionsArray.push(
        <div  key='2'>
          <div style={{display: "-webkit-flex",WebkitJustifyContent:'flex-end',marginTop:'0.3rem'}}>
            <p >
              {this.state.questionnaireNumber}
            </p>
            <p >
              {'/'+this.state.questionnaireTotalNumber}
            </p>
          </div>
        </div>
      ):
      optionsArray.push(
        <div style={{display: "-webkit-flex",WebkitJustifyContent:'space-between',marginTop:'0.31rem'}} key='2'>
          <div onClick = {()=>{this.setState({questionnaireNumber: this.state.questionnaireNumber-1, disableSelectItem: false});this.answers.pop()}}>
            <p >上一题</p>
          </div>
          <div style={{display: "-webkit-flex",WebkitJustifyContent:'flex-end'}}>
            <p >
              {this.state.questionnaireNumber}
            </p>
            <p >
              {'/'+this.state.questionnaireTotalNumber}
            </p>
          </div>
        </div>
      )
    }


    // 最后一页问题列表
    if(this.state.questionnaireNumber==this.state.questionnaireTotalNumber){
      optionsArray.push(
        <p className='share' style = { {color: '#5b6370',height:'auto'} } key='1'>
          {`${this.state.questionnaireNumber}、${this.state.questionnaireArray[this.state.questionnaireNumber-1].content}`}
        </p>
      )
      for (let i = 0; i < this.state.questionnaireArray[this.state.questionnaireNumber-1].options.length; i++) {
        optionsArray.push(
          <div onClick={()=>{this.setState({questionnaireSelectedOption: this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].optionId, disableSelectItem: true});this.handleSaveRiskResult(this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].optionId)} }>
            <div  style={{display: "-webkit-flex",WebkitAlignItems:'center',background: '#fff',borderBottom: '1px solid rgba(242,245,247,1)',height:'62px'}}>
              { this.state.questionnaireSelectedOption==this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].optionId?
                <img style={{width:'0.88rem',height:'0.88rem'}}  src={require('../../img/protocol_selected.png')} />:
                <img style={{width:'0.88rem',height:'0.88rem'}} src={require('../../img/square.png')} />
              }
              <p >{this.state.questionnaireArray[this.state.questionnaireNumber-1].options[i].content}</p>
            </div>
          </div>
        )
      }
      optionsArray.push(
         <div style={{display: "-webkit-flex",WebkitJustifyContent:'space-between',marginTop:'0.31rem'}} key='2'>
          <div onClick = {()=>{this.setState({questionnaireNumber: this.state.questionnaireNumber-1, disableSelectItem: false});this.answers.pop()}}>
            <p >上一题</p>
          </div>
          <div style={{display: "-webkit-flex",WebkitJustifyContent:'flex-end'}}>
            <p >
              {this.state.questionnaireNumber}
            </p>
            <p >
              {'/'+this.state.questionnaireTotalNumber}
            </p>
          </div>
        </div>
      )
    }
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>公募答题问卷</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content' style={{fontSize:'13px'}}>
            {optionsArray}
          </div>
          <ModelEvaluation></ModelEvaluation>
          {
            this.state.alertFlag?
             <AlerModleCommon 
             btnTxt1="确认终止"
             btnTxt2="重新测评"
             content={this.state.alertContent} 
             title="风险提示"
             handleClick1 = { this.closeMoadl.bind(this) }
             handleClick2 = { this.handleGo.bind(this) }
           /> : null
          }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {

  }
}
export default connect(mapStateToProps)(QuestionnaireList);



// WEBPACK FOOTER //
// ./src/components/pubQuestion/QuestionnaireList.js